import * as config from './config';

export const languages = [
	'English',
	'French',
	'Chinese',
	'Telugu',
	'Hindi',
	'Spanish',
	'Tamil',
	'Japanese',
];

export const questionTypes = {
	choiceDropdownSingle: 'Choice Dropdown Single',
	// choiceDropdownMultiple: 'Choice Dropdown Multiple',
	choiceRadio: 'Choice Radio',
	choiceCheckBox: 'Choice Checkbox',
	textField: 'Text Field',
	textArea: 'Text Area',
	paragraph: 'Paragraph',
	rating: 'Rating',
	thumbsUpDown: 'ThumbsUpDown',
};

export { config };

export default config;
